import React from "react";

export const initialContext = {
  inputsValidated: true,
  customerError: "",
  selectedContracts: [], // ["id"]
}

export default React.createContext(initialContext);
